import React, { useEffect, useState } from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../../routes/routeName'
import StatusCustom from '../../../../components/status/statusCustom'
import { Typography } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import Divider from '@mui/material/Divider';
import StateComponents from '../../../../components/state-component/StateComponents'
import { ONLINE_COURSE_PAYMENT, renderStatus } from './enum/enum.payment'
import ContainerButton from '../../../../components/button/ContainerButton'
import { alertActive, alertSuccess } from '../../../../components/alert/swal'
import { OnlineCoursePaymentApi } from '../../../../api/online-course-payment-master/online_course_payment_master.api'
import { useDispatch } from 'react-redux'
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

type Props = {
    view: boolean;
}

const ManageCourseOnlinePaymentDetail: React.FC<Props> = ({ view }: Props) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const [status, setStatus] = useState<string>(ONLINE_COURSE_PAYMENT.CONFIRMED);
    const [data, setData] = useState<any>(null);
    const [pathUrl, setPathUrl] = useState<string>("");


    const handleSubmit = (id_online_course_payment: number, mode: "REJECT" | "APPROVE") => {
        alertActive(mode === 'APPROVE' ? t("ยืนยันการชำระเงิน") : t("ไม่อนุมัติ"), mode === 'APPROVE' ? t("ท่านต้องการยืนยันการชำระเงิน ใช่หรือไม่?") : t("ท่านต้องการปฏิเสธ ใช่หรือไม่?"), undefined, undefined, async () => {
            if (mode === 'APPROVE') {
                await OnlineCoursePaymentApi.updateStatus(id_online_course_payment, {
                    is_confirm: ONLINE_COURSE_PAYMENT.CONFIRMED
                }).then((res) => {
                    if (res.status < 300) {
                        handleGetDetail(id_online_course_payment);
                        alertSuccess(t("ยืนยันการชำระเงิน"), t("ยืนยันการชำระเงิน เรียบร้อยแล้ว"))
                    }
                }).catch((err) => {
                    console.log(err)
                })
            } else {
                await OnlineCoursePaymentApi.updateStatus(id_online_course_payment, {
                    is_confirm: ONLINE_COURSE_PAYMENT.REJECT
                }).then((res) => {
                    if (res.status < 300) {
                        handleGetDetail(id_online_course_payment);
                        alertSuccess(t("ไม่อนุมัติ"), t("ไม่อนุมัติ เรียบร้อยแล้ว"))
                    }
                }).catch((err) => {
                    console.log(err)
                })
            }
        })
    }

    const handleGetDetail = async (id_online_course_payment: number) => {
        dispatch(setLoading());
        await OnlineCoursePaymentApi.findOne(id_online_course_payment).then((res) => {
            if (res.status < 300) {
                const data_value = res.data?.data || null;
                if (data_value?.online_course_payment_status) {
                    setStatus(data_value?.online_course_payment_status)
                }
                setData(res.data?.data || null);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    useEffect(() => {
        if (id && !isNaN(+id)) {
            handleGetDetail(+id)
        }
    }, [])

    useEffect(() => {
        const init = async () => {
            const response = await fetch("/resources/config.json");
            const results = await response.json();
            setPathUrl(results?.REACT_APP_BASE_API_PUBLIC || "");
        };
        init();
    }, []);

    return (
        <ContainerLayout
            title={t("รายละเอียดการสั่งซื้อ")}
            sub_title_custom={
                <StatusCustom
                    disableMaxWidth
                    text={renderStatus(status)}
                    type={renderStatus(status)}
                />
            }
            hidden_sub_title
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: t("จัดการข้อมูลคอร์สออนไลน์"),
                            name: t("จัดการข้อมูลคอร์สออนไลน์"),
                            pathName: "",
                            disabled_match: true
                        },
                        {
                            key: t("จัดการรายการสั่งซื้อ"),
                            name: t("จัดการรายการสั่งซื้อ"),
                            pathName: routeName.cms.course_online_payment,
                        },
                        ...((view && id) ? [
                            {
                                key: t("รายละเอียดการสั่งซื้อ"),
                                name: t("รายละเอียดการสั่งซื้อ"),
                                pathName: routeName.cms.course_online_payment_view.replace(":id", id),
                            },
                        ] : id ? [
                            {
                                key: t("รายละเอียดการสั่งซื้อ"),
                                name: t("รายละเอียดการสั่งซื้อ"),
                                pathName: routeName.cms.course_online_payment_detail.replace(":id", id),
                            },
                        ] : [])
                    ]}
                />
            }
            buttonContent={
                <ContainerButton
                    justifyContent='flex-end'
                    buttonData={[
                        {
                            key: "CANCEL",
                            buttonProps: {
                                onClick: () => navigate(routeName.cms.course_online_payment)
                            },
                            label: t("ย้อนกลับ"),
                            seq: 1,
                            type: "CANCEL",
                        },
                        {
                            key: "REJECT",
                            buttonProps: {
                                onClick: () => id && !isNaN(+id) && handleSubmit(+id, 'REJECT')
                            },
                            hidden: status !== ONLINE_COURSE_PAYMENT.PENDING,
                            label: t("ไม่อนุมัติ", { context: "action" }),
                            seq: 2,
                            type: "REJECT",
                        },
                        {
                            key: "APPROVE",
                            buttonProps: {
                                onClick: () => id && !isNaN(+id) && handleSubmit(+id, 'APPROVE')
                            },
                            hidden: status !== ONLINE_COURSE_PAYMENT.PENDING,
                            label: t("ยืนยันการชำระเงิน"),
                            seq: 3,
                            type: "APPROVE",
                        },
                    ]}
                />
            }
            content={
                <div className='w-full h-full'>
                    <section className='h-full grid grid-cols-12 gap-8'>
                        <article className='h-full flex flex-col col-span-12 lg:col-span-7 bg-[#F6F6F6] rounded-xl p-10 lg:p-[40px]'>
                            <Typography variant='h5'>
                                {t("บิลเลขที่")} {data?.online_course_payment_no || "-"}
                            </Typography>
                            <span className='flex justify-between gap-4 items-center mt-5'>
                                <div>
                                    <Typography fontWeight={600} variant='h6'>
                                        {t("ชื่อลูกค้า")}
                                    </Typography>
                                </div>
                                <div>
                                    {data?.order_by || "-"}
                                </div>
                            </span>
                            <span className='flex justify-between items-center mt-5'>
                                <div>
                                    <Typography fontWeight={600} variant='h6'>
                                        {t("ออกบิลเมื่อ")}
                                    </Typography>
                                </div>
                                <div>
                                    {data?.payment_date_time ? new Date(data?.payment_date_time).toLocaleDateString(i18n.language === "en" ? "en-GB" : "th-TH", {
                                        year: "numeric",
                                        month: "long",
                                        day: "numeric"
                                    }) : "-"}
                                </div>
                            </span>
                            <span className='flex justify-between items-center mt-5'>
                                <div>
                                    <Typography fontWeight={600} variant='h6'>
                                        {t("กรุณาชำระก่อน")}
                                    </Typography>
                                </div>
                                <div>
                                    {data?.online_course_payment_date ? new Date(data?.online_course_payment_date).toLocaleDateString(i18n.language === "en" ? "en-GB" : "th-TH", {
                                        year: "numeric",
                                        month: "long",
                                        day: "numeric"
                                    }) : "-"}
                                </div>
                            </span>
                            <Divider sx={{ my: 5, borderStyle: "dashed", borderWidth: 1.5 }} />
                            <div className='w-full flex flex-col gap-2'>
                                <span>
                                    <Typography variant='h6'>
                                        {data?.online_course_name || "-"}
                                    </Typography>
                                </span>
                                <span>
                                    <Typography variant='h6'>
                                        {data?.online_course_description || "-"}
                                    </Typography>
                                </span>
                                <span>
                                    {data?.online_course_teacher || "-"}
                                </span>
                                <span className='w-full flex justify-between'>
                                    <div>{t("จำนวน 1 รายการ")}</div>
                                    <div> {data?.payment_amount ? Number(data?.payment_amount || 0).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }) : "0"} {t("บาท")}</div>
                                </span>
                            </div>
                            <Divider sx={{ my: 5, borderStyle: "dashed", borderWidth: 1.5 }} />
                            <div className='w-full h-fit pt-20 flex flex-1 justify-between items-end'>
                                <Typography fontWeight={600} variant='h6'>
                                    {t("ยอดสุทธิ")}
                                </Typography>
                                <Typography fontWeight={600} variant='h6'>
                                    {data?.payment_amount ? Number(data?.payment_amount || 0).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }) : "0"} {t("บาท")}
                                </Typography>
                            </div>
                        </article>
                        <article className='h-full flex flex-col gap-4 col-span-12 lg:col-span-5 bg-[#F6F6F6] rounded-xl'>
                            <span className='w-full p-4 lg:p-10 h-full lg:min-h-[600px]'>
                                <img width={'100%'} height={'100%'} className='object-cover' src={data?.file_path ? `${pathUrl}/` + data?.file_path + data?.file_name : 'https://placehold.co/600x400?text=No-Image'} alt="sl" />
                            </span>
                            <span className='w-full p-4'>
                                <StateComponents
                                    otherProps={{ spacing: 2 }}
                                    typeProps={[
                                        {
                                            seq: 1,
                                            type: "DATE",
                                            gridProps: {
                                                xs: 12,
                                                lg: 4
                                            },
                                            fieldProps: {
                                                disabled: true,
                                                onChange: () => { },
                                                value: data?.payment_date_time ? moment(data?.payment_date_time).format("YYYY-MM-DD") : "",
                                                heading: t("วันที่ชำระเงิน")
                                            }
                                        },
                                        {
                                            seq: 2,
                                            type: "TIME_PICKER",
                                            gridProps: {
                                                xs: 12,
                                                lg: 4
                                            },
                                            fieldProps: {
                                                onChange: () => { },
                                                value: data?.payment_date_time ? moment(data?.payment_date_time).format("HH:mm") : "",
                                                disabled: true,
                                                heading: t("เวลาชำระเงิน")
                                            }
                                        },
                                        {
                                            seq: 3,
                                            type: "TEXT-MASK",
                                            gridProps: {
                                                xs: 12,
                                                lg: 4
                                            },
                                            fieldProps: {
                                                disabled: true,
                                                onChange: () => { },
                                                value: `${data?.payment_amount || ""}` || "",
                                                heading: t("จำนวนยอดเงิน (บาท)"),
                                                mode: "amount"
                                            }
                                        },
                                    ]}
                                />
                            </span>
                        </article>
                    </section>
                </div>
            }
        />
    )
}

export default ManageCourseOnlinePaymentDetail